import { connect } from 'react-redux';

import { withRouter } from 'src/router/utils';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';
import { safeDecodePath } from 'src/utils/path';

import loadFileMeta from '../actions/load-file-meta';
import FileFetcher from '../components/file-fetcher';

const mapStateToProps = (state: BucketState) => ({
  hash: state.repository.source.section.hash,
  repository: getCurrentRepository(state),
});

const mapDispatchToProps = { loadFileMeta };

// @ts-ignore TODO: fix noImplicitAny error here
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  path: safeDecodePath(ownProps.match.params.path || ''),
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(FileFetcher)
);
